import React, { useState } from 'react';
import search from '../../images/search.svg'
import open from '../../images/icons/open.svg'
import close from '../../images/icons/close.svg'
import contact from '../../images/contact.svg'
import lightning from '../../images/icons/lightning.svg';
import axios from 'axios';


function ContactBody(props) {
        const [currentFaq, setCurrentFaq] = useState()
        const [faqs, setFaqs] = useState([
            {id:1,question:'Is there free trial available',answer:'There is an option to set up a free account, however you will be limited in functionalities usage'},
            {id:2,question:'Can I change my plan later?',answer:'You can always upgrade or downgrade your plan anytime, terms and conditions apply.'}
        ])
    
        const changeFaq = (faq) => {
            if(currentFaq == faq) setCurrentFaq(0)
            else setCurrentFaq(faq)
        }

        const [contactData, setContactData] = useState({})
        const [contactDataFull, setContactDataFull] = useState({leadType:2})
        const [processing, setProcessing] = useState()
        const SubmitContact = (e) => {
            e.preventDefault()
            contactDataFull.capturedData = JSON.stringify(contactData) 
            setProcessing(1)
            axios.post(process.env.REACT_APP_BASE_URL+'/Lead/Create',contactDataFull,{})
            .then((res) => {
                if(res.status == 200){
                    alert('Your message has been delivered successfully, please look out for a feedback from us as soon as possible')
                    setProcessing(0)
                    //window.location.href=''
                }}
            )
            .catch((e) => {
                console.log(e)
            })
        }
    return (
        <>
            <div className="bg-[url('images/faqsheader.svg')] flex-col items-center py-6 pb-10">
                <div className='text-white text-[30px] lg:text-[48px] font-[500] lg:w-[60%] mx-auto mt-5'>Contact Us</div>
                <div className='font-[400] text-[24px] text-white pt-2 pb-10 lg:w-[62%] mx-auto'>Have a question? Need help? Contact us today.s.</div>
            </div>
            <div className='px-10 lg:px-20 mb-0 lg:mb-10 grid grid-cols-8 py-10 lg:pt-20 lg:gap-x-10 space-y-4 lg:space-y-0'>
                <div className='col-span-8 lg:col-span-4 flex flex-col text-start space-y-4 my-auto'>
                    <div className='flex flex-col'>
                        <span className='font-[500] text-[30px] lg:text-[48px] text-[#101828]'>Get in touch</span>
                        <span>Our dedicated support team is here to assist you.</span>
                    </div>
                    <form onSubmit={SubmitContact} className='flex flex-col space-y-5 '>
                        <div className='grid grid-cols-2 space-y-4'>
                            <div className='col-span-2 flex flex-col space-y-2'>
                                <label className='text-[14px] text-[#344054]'>Full Name</label>
                                <input onChange={(e) => setContactData({...contactData,name:e.target.value})} required type="text" className='rounded-[8px] border-[1px] border-[#D0D5DD] h-[48px] pl-3 outline-none' placeholder='Full Name' />
                            </div>
                            <div className='col-span-2 flex flex-col space-y-2'>
                                <label className='text-[14px] text-[#344054]'>Email</label>
                                <input onChange={(e) => setContactDataFull({...contactDataFull,email:e.target.value})} required type="email" className='rounded-[8px] border-[1px] border-[#D0D5DD] h-[48px] pl-3 outline-none' placeholder='Email' />
                            </div>
                            <div className='col-span-2 flex flex-col space-y-2'>
                                <label className='text-[14px] text-[#344054]'>Message</label>
                                <textarea onChange={(e) => setContactData({...contactData,message:e.target.value})} required type="text" className='rounded-[8px] border-[1px] border-[#D0D5DD] h-[128px] pl-3 outline-none' />
                            </div>
                        </div>
                        <div><button className='bg-[#008B39] text-white border-[1px] border-[#008B39] rounded-[32px] py-3 w-full'>Send message</button></div>
                    </form>
                </div>
                <div className='col-span-8 lg:col-span-4'><img src={contact} /></div>
            </div>
            <div className='flex flex-col px-10 lg:px-20 lg:py-20 mb-10'>
                <div className='text-[30px] lg:text-[48px] font-[400] mb-3 lg:mb-0'>Send Us A Message</div>
                <div className='grid grid-cols-6 gap-y-5 lg:gap-y-0 lg:gap-x-5 mt-5 lg:mt-10'>
                    <div className='col-span-6 lg:col-span-2 bg-[#FBFBFB] flex flex-col text-start space-y-4 rounded-[4px] p-3'>
                        <span><img src={lightning} /></span>
                        <span className='flex flex-col'>
                            <span className='text-[#121212] text-[24px]'>Reach Us</span>
                            <span className='text-[#6D7076] text-[16px]'>Speak with our team</span>
                        </span>
                        <span className='text-[#0E0E0E] text-[20px]'>business@yebokenny.com</span>
                    </div>
                    <div className='col-span-6 lg:col-span-2 bg-[#FBFBFB] flex flex-col text-start space-y-4 rounded-[4px] p-3'>
                        <span><img src={lightning} /></span>
                        <span className='flex flex-col'>
                            <span className='text-[#121212] text-[24px]'>Visit Us</span>
                            <span className='text-[#6D7076] text-[16px]'>Visit Our Office</span>
                        </span>
                        <span className='text-[#0E0E0E] text-[20px]'>Pietermaritzburg</span>
                    </div>
                    <div className='col-span-6 lg:col-span-2 bg-[#FBFBFB] flex flex-col text-start space-y-4 rounded-[4px] p-3'>
                        <span><img src={lightning} /></span>
                        <span className='flex flex-col'>
                            <span className='text-[#121212] text-[24px]'>Call Us</span>
                            <span className='text-[#6D7076] text-[16px]'>Speak with our team</span>
                        </span>
                        <span className='text-[#0E0E0E] text-[20px]'>+27 33 492 0174</span>
                    </div>
                </div>
            </div>
        </>

    );
}

export default ContactBody;